import { trackMpEvent } from '@/helpers';
import { useEffect } from 'react';

type ScreenShownProperties = {
  screen_name: string;
  initiated_from?: string;
};

export function trackScreenShown(event: ScreenShownProperties) {
  trackMpEvent('screen_shown', event);
}

const useTrackScreenShown = (event: ScreenShownProperties, deps: unknown[] = [], conditions: boolean[] = []) => {
  useEffect(() => {
    conditions.every((condition) => condition) && trackScreenShown(event);
  }, deps);
};

export default useTrackScreenShown;
